import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { AuthenticatedImage } from '../ui/AuthenticatedImage';

/**
 * E‑commerce style design image preview.
 * Uses the same designImage key already on the object — AuthenticatedImage
 * serves from the in-memory blob cache when the thumbnail was already shown,
 * so opening preview does not re-fetch from cloud storage.
 */
export function DesignImagePreviewModal({ open, onClose, design }) {
  if (!design) return null;

  const sampleNo = String(design.sampleNo || design.designSampleNo || '').trim();
  const image = String(design.designImage || '').trim();
  const note = String(design.note || '').trim();
  const title = sampleNo ? `Design #${sampleNo}` : 'Design preview';

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="3xl"
      title={title}
      footer={
        <Button type="button" variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="space-y-4">
        <div className="flex min-h-[min(60vh,520px)] items-center justify-center overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-50">
          {image ? (
            <AuthenticatedImage
              src={image}
              alt={sampleNo ? `Design ${sampleNo}` : 'Design preview'}
              className="max-h-[min(70vh,640px)] w-full object-contain"
            />
          ) : (
            <p className="py-20 text-sm text-slate-500">No image available</p>
          )}
        </div>
        {note ? (
          <div className="rounded-xl border border-slate-200 bg-white px-4 py-3">
            <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Note</p>
            <p className="mt-1 whitespace-pre-wrap text-sm font-medium text-slate-800">{note}</p>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}
